var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveIconTimesheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.4,
    fill: "#FFFFFF",
    stroke: "#193C6D",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25935_107681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.19995,
    y: 7.2002,
    width: 21.6,
    height: 21.6,
    fill: "#193C6D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25935_107681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4822 24L10 18.3369L11.0986 17.2018L15.4822 21.73L24.9014 12L26 13.1351L15.4822 24Z",
    fill: "#193C6D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIconTimesheet);
export default __webpack_public_path__ + "static/media/approveIconTimesheet.5d4bdb0b47f1605289bdea98fa0d25ad.svg";
export { ForwardRef as ReactComponent };